import { userConstants } from "../../constant";

export function rating(state = { count: 0 }, action) {
  switch (action.type) {
    case userConstants.STAR_RATING:
      return {
        count: action.count,
      };
    default:
      return state;
  }
}
